// frontend/src/components/ArtistDetailsPopup.js
import React from 'react';
import { FaTimes } from 'react-icons/fa'; // Import FaTimes icon
import {BASE_URL} from '../controllers/dataController';

const ArtistDetailsPopup = ({ artist, onClose }) => {
    if (!artist) return null;

    // Stop propagation for clicks inside the modal content
    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className=' bg-black/70 z-50 fixed inset-0 flex items-center justify-center w-full h-full' onClick={onClose}>
        <div className=" flex w-[70%] h-70 justify-center items-center" >
            <div
                className="bg-gray-800 rounded-lg p-6 w-11/12 md:w-3/4 lg:w-1/2 xl:w-2/5 max-h-[80vh] flex flex-col" // Added flex flex-col for scrollable content
                onClick={handleContentClick}
            >
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-semibold text-white">Artist Details</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-white p-2 rounded-full hover:bg-gray-700">
                        <FaTimes /> {/* Using FaTimes icon */}
                    </button>
                </div>
                <div className="space-y-4 text-gray-300 overflow-y-auto pr-2"> {/* Added overflow-y-auto and pr-2 for scrollbar spacing */}
                    <div>
                        <h4 className="font-semibold text-white">Artist ID</h4>
                        <p>{artist.artist_id}</p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-white">Labels</h4>
                        <ul className="list-disc list-inside ml-5"> {/* Added ml-5 for better indentation */}
                            {artist.labels.map((label, index) => <li key={index}>{label}</li>)}
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-semibold text-white">Artist Names</h4>
                        <ul className="list-disc list-inside ml-5">
                            {artist.artist_names.map((name, index) => <li key={index}>{name}</li>)}
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-semibold text-white">Platforms</h4>
                        <ul className="list-disc list-inside ml-5">
                            {artist.platforms.map((platform, index) => 
                            <li key={index}>
                                <img
                                    src={`${BASE_URL}/icons/${platform}`}
                                    alt={platform.name}
                                    className="inline-block w-5 h-5 mr-2 rounded-full object-cover"
                                />
                                <div className="inline-block align-middle">
                                {platform} 
                                </div>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-semibold text-white">Song Names</h4>
                        <ul className="list-disc list-inside ml-5">
                            {artist.song_names.map((song, index) => <li key={index}>{song}</li>)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default ArtistDetailsPopup;